import { Component, OnInit,Input,HostListener } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { AlertController, MenuController,LoadingController, ModalController,AnimationController, Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';

@Component({
  selector: 'app-variant-mapping',
  templateUrl: './variant-mapping.component.html',
  styleUrls: ['./variant-mapping.component.scss'],
})
export class VariantMappingComponent  implements OnInit {

  @Input() product_values;
  variant_list:any = [];
  check_box_value = false;
  constructor(public modalCtrl: ModalController,public db:DataService, public storage: Storage) { } 

  ngOnInit() {
    console.log(this.db.inventory_items);
    let k = 0;
    this.product_values.variants.map((res,i)=>{
     let value = this.db.inventory_items.find(r=> r.attribute_id == res.attribute_id);
     if(value){
      k++;
      res['isActive'] = true;
      this.variant_list.push(res);
     }else{
      res['isActive'] = false;
     }

     ((this.product_values.variants.length == (i + 1)) && (i + 1) == k) ? this.check_box_value = true: null

    })

    const modalState = {
      modal : true,
      desc : 'fake state for our modal'
    };
    history.pushState(modalState, '');

  }

  @HostListener('window:popstate', ['$event'])
  dismissModal() {
    this.modalCtrl.dismiss();
  }


  add_variant(selected_item,index){
    selected_item['isActive'] = selected_item['isActive'] ? false : true;

    if(selected_item['isActive']){
      this.variant_list.push(selected_item);
    }
    
    let count = this.product_values.variants.filter(res=>{return res.isActive == true})


    if(count.length == this.product_values.variants.length){
      this.check_box_value = true;
    }else{
      this.check_box_value = false;
    }

    // this.save('');
  }

  save(type){
    // console.log(this.variant_list);
    // let selected_values = this.variant_list.filter(res=>{return res.isActive == true})
    // if(selected_values.length == 0){
    //   this.db.alert('Please select any of variant');
    // }else{
      // let data = {'status': 'success','data':this.variant_list}
      let length = this.db.inventory_items.length;
      this.variant_list.map((res,i)=>{
        if(res.isActive == true){
          let obj = JSON.stringify(this.product_values);
          obj = JSON.parse(obj);
          obj['variants'] = [];
          obj['attribute_id'] = res.attribute_id;
          obj['sku'] = res.sku;
          obj['variants'].push(res);
          let value = this.db.inventory_items.find(r=> r.attribute_id == res.attribute_id);
          value ? null : this.db.inventory_items.push(obj); 
        }else{
          let find_index = this.db.inventory_items.findIndex(r=> r.attribute_id == res.attribute_id)
          if(find_index >= 0){
            this.db.inventory_items.splice(find_index,1);
          }
        }
        
        if(this.variant_list.length == (i + 1)){
          this.storage.set('inventroy_items', this.db.inventory_items);
        } 

        this.db.check_added_values(this.db.cat_products);
        
      })

      setTimeout(()=>{
        let last_count = this.db.inventory_items.length - 1;
        (length < this.db.inventory_items.length) ?  this.db.added_animate.next({'item': this.db.inventory_items[last_count].item,'images':this.db.inventory_items[last_count].product_image ,'add_to_cart':1 }) : null
        // this.db.added_animate.next({'item': this.db.inventory_items[last_count].item,'images':this.db.inventory_items[last_count].product_image})
      },500)

      type == 'close' ? this.modalCtrl.dismiss() : null;
    // }
  }



  check_box(eve,array_list){

    let value = eve.detail.checked;
    let array:any = [];
    if(value){
      array_list.map(res=>{
        res['isActive'] = true;
        array.push(res)
      })
      this.variant_list = array;
    }else{
      array_list.map(res=>{
        res['isActive'] = false;
        array.push(res)
      })
      this.variant_list = array;
    }

    console.log(array_list);

  }

  select_all(array_list){
    let array:any = [];
    array_list.map(res=>{
      res['isActive'] = true;
      array.push(res)
    })
    this.variant_list = array;
    this.save('close');
    
  }

  close_modal(){
    // this.db.centres_list = [];
    this.modalCtrl.dismiss();
  }

}
